export default __webpack_public_path__ + "static/media/SortDescending.108b5a20.svg";